import { routes } from "src/constants/routes.constants.ts";

export const createModuleRoutePaths = ({
  resource,
  basePath = routes.admin.root,
}: {
  resource: string;
  basePath?: string;
}) => {
  return {
    root: `${basePath}/${resource}`,
    edit: {
      root: `${basePath}/${resource}/:id`,
      tab: (id: string) => ({
        root: `${basePath}/${resource}/:id/${id}`,
        tab: (subTabId: string) => ({
          root: `${basePath}/${resource}/:id/${id}/${subTabId}`,
          tab: (subSubTabId: string) => ({
            root: `${basePath}/${resource}/:id/${id}/${subTabId}/${subSubTabId}`,
          }),
        }),
      }),
    },
    create: {
      root: `${basePath}/${resource}/create`,
      tab: (id: string) => ({
        root: `${basePath}/${resource}/create/${id}`,
      }),
    },
  };
};
